<div class="IUC">

    <div v-if="showDropZoneWrapper" class="IUC__file-input-wrapper" ref="dropZone"
        :class="uploaderOptions.uploaderStyleClass"
        @drop="onDrop"
        @dragenter="onDragEnter"
        @dragleave="onDragLeave"
        @dragover="onDragOver">

        <span v-if="uploaderOptions.showDropZone" class="IUC__drop-zone-text">
            <mom-icon class="IUC__upload-icon" svgIcon="upload"></mom-icon>
            <p>{{ uploaderOptions.uploadDropZoneText}}</p>
        </span>
        <mom-button v-else-if="!uploaderOptions.useCustom" class="m-button--smoke">
            <mom-icon class="IUC__upload-icon" svgIcon="upload"></mom-icon>
            <span>{{ uploaderOptions.uploadButtonText }}</span>
        </mom-button>
        <slot v-else></slot>

        <input class="IUC__file-input" type="file" ref="fileInput" accept="image/*"
            :multiple="uploaderOptions.allowMultipleImages" @change="onFileChange" title=" "/>
    </div>

    <div class="IUC__error" v-if="error.length > 0">{{ error }}</div>

    <div class="IUC__error" v-if="showErrors">
        <p v-for="error in invalidImageErrors">{{ error }}</p>
    </div>

    <image-gallery v-if="uploaderOptions.showDefaultGallery && (!showDropZoneWrapper || uploaderOptions.allowMultipleImages)"
        :options="imageGalleryOptions"
        @close="onCloseImage" :isLoading="isLoading"></image-gallery>
</div>
